import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const HOURS = Array.from({ length: 24 }, (_, h) => ({ h, label: `${h % 12 || 12}:00 ${h < 12 ? "AM" : "PM"}` }));
export const browserTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const RecapSchedule = ({ day, hour, tz, onChange, disabled }) => (
  <div className="mt-4" data-testid="recap-schedule">
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span className="text-mm-muted">Send on</span>
      <Select value={String(day)} onValueChange={(v) => onChange({ recap_day: Number(v) })} disabled={disabled}>
        <SelectTrigger className="w-36 rounded-xl" data-testid="recap-day-select"><SelectValue /></SelectTrigger>
        <SelectContent>{DAYS.map((d, i) => <SelectItem key={d} value={String(i)} data-testid={`recap-day-${i}`}>{d}</SelectItem>)}</SelectContent>
      </Select>
      <span className="text-mm-muted">at</span>
      <Select value={String(hour)} onValueChange={(v) => onChange({ recap_hour: Number(v) })} disabled={disabled}>
        <SelectTrigger className="w-32 rounded-xl" data-testid="recap-hour-select"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-64">{HOURS.map(({ h, label }) => <SelectItem key={h} value={String(h)} data-testid={`recap-hour-${h}`}>{label}</SelectItem>)}</SelectContent>
      </Select>
    </div>
    <div className="text-xs text-mm-muted mt-2 flex flex-wrap items-center gap-2">
      <span data-testid="recap-timezone">Your time zone: {tz}</span>
      {tz !== browserTz() && (
        <button className="text-mm-primary font-semibold" onClick={() => onChange({ recap_timezone: browserTz() })} data-testid="recap-use-browser-tz">Use {browserTz()}</button>
      )}
    </div>
  </div>
);
